import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Modal, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}));

const ConfirmationModal = ({ open, handleClose, title, message, handleConfirmation }) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className={classes.modal}
    >
      <div className={classes.paper}>
        <Typography
          variant="h6"
          gutterBottom
        >
          {title}
        </Typography>

        <Typography variant="body1">
          {message}
        </Typography>

        <div style={{ marginTop: 16 }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClose}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={handleConfirmation}
            style={{ marginLeft: 16 }}
          >
            Confirmar
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  handleConfirmation: PropTypes.func.isRequired,
};

export default ConfirmationModal;